var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BowContentMedia',{attrs:{"type":"dx","cta":_vm.cta,"htmlTag":_vm.htmlTag,"media":_vm.media,"mediaToggle":_vm.mediaToggle,"text":_vm.text,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }